<template>
  <div
    :class="inputStyleClasses + ' flex items-center gap-2 self-stretch'"
    style="border-style: solid"
  >
    <div class="flex flex-[1_0_0] items-center gap-2">
      <div
        class="flex h-[24px] w-[34px] items-center justify-center rounded border border-[#f2f4f7] bg-white"
      >
        <MasterCardIcon></MasterCardIcon>
      </div>
      <div :class="inputTextStyleClasses + ' flex-[1_0_0]'">{{ t("common.enterCardNumber") }}</div>
    </div>
  </div>
  <div
    class="flex min-w-[192px] flex-wrap content-start items-start justify-between gap-2 self-stretch"
  >
    <div
      :class="inputStyleClasses + ' flex flex-[1_0_0] items-center gap-2 self-stretch'"
      style="border-style: solid"
    >
      <div :class="inputTextStyleClasses">{{ t("common.mmYy") }}</div>
    </div>
    <div
      :class="inputStyleClasses + ' flex flex-[1_0_0] items-center gap-2 self-stretch'"
      style="border-style: solid"
    >
      <div class="flex w-[100%] items-center justify-between gap-2">
        <div :class="inputTextStyleClasses">{{ t("common.threeDigitCode") }}</div>
        <EyeIcon class="block h-[16px] w-[16px] text-gray-400"></EyeIcon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MasterCardIcon from "@/assets/icons/mastercard.svg";
import { EyeIcon } from "@gohighlevel/ghl-icons/24/outline";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const inputStyleClasses =
  "form-input-border-style shadow-[0_1px_2px_0_rgba(16,24,40,0.05)] p-[8px]";
const inputTextStyleClasses =
  "text-[#667085] font-sans text-base not-italic font-normal leading-6 tracking-normal";
</script>
